module.exports = __webpack_public_path__ + "img/12.b8a7d0f2.png";